import { colors, FelaCSS, FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: (themeIndex: number) => FelaCSSWithCustomSelectors;
  content: FelaCSS;
  header: FelaCSS;
  avatar: FelaCSS;
  name: FelaCSS;
  ratingBox: FelaCSS;
  date: FelaCSS;
  title: FelaCSS;
  body: FelaCSS;
  swirlBox: FelaCSS;
}

const themeStyles = [
  {
    background: colors.peachRose20,
    '& svg > path': {
      stroke: colors.peachRose40,
    },
  },
  {
    background: colors.indigoCrush10,
    '& svg > path': {
      stroke: colors.indigoCrush20,
    },
  },
  {
    background: colors.teal20,
    '& svg > path': {
      stroke: colors.teal60,
    },
  },
];

const styles = (): IStyles => ({
  wrapper: (theme) => ({
    position: 'relative',
    padding: `${spacing[6]} ${spacing[4]}`,
    color: colors.space,
    fontDefault: 14,
    borderRadius: spacing[3],
    overflow: 'hidden',
    height: '100%',
    marginRight: spacing[6],

    ...themeStyles[theme],

    maxWidthTabletSm: {
      margin: `${spacing[0]} ${spacing[3]}`,
    },
  }),
  content: {
    zIndex: 2,
  },
  header: {
    flexDirection: 'row',
    gap: spacing[2],
    marginBottom: 2,
  },
  avatar: {
    width: spacing[12],
    height: spacing[12],
    borderRadius: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.space04,
    fontDefaultSemiBold: 24,
    textTransform: 'uppercase',
  },
  name: {
    fontSize: 16,
    lineHeight: '14px',
    marginBottom: 2,
  },
  ratingBox: {
    flexDirection: 'row',
    gap: spacing[2],
    alignItems: 'center',
  },
  date: {
    fontDefault: 12,
    color: colors.space60,
    lineHeight: '14px',
  },
  title: {
    fontDefaultSemiBold: 18,
    lineHeight: '120%',
    marginBottom: 2,
  },
  body: {
    lineHeight: '150%',
    letterSpacing: '-0.28px',
  },
  swirlBox: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
  },
});

export default styles;
